import React, { FC, ReactElement } from 'react';
import { Typography, Grid, Fade, CircularProgress } from '@material-ui/core';
import { CarregandoProps } from './carregando-props';
import { useStyles } from './carregando-styles';
import { Skeleton } from '@material-ui/lab';
import classNames from 'classnames';
import { DocumentTitle } from 'components';
import { VariaveisAmbiente } from 'ambiente';
import { MasterPagina } from 'views/pages/templates';

export const Carregando: FC<CarregandoProps> = ({
  tipo = 'spinner',
  skeletonVariant,
  width,
  height,
  carregando,
  mensagem,
  titulo,
  className,
  modelo,
  preencherBackground,
}) => {
  const classes = useStyles();
  const tituloDocument: ReactElement = (
    <DocumentTitle titulo={VariaveisAmbiente.appName + ' - Carregando...'}></DocumentTitle>
  );

  if (tipo === 'skeleton') {
    return (
      <React.Fragment>
        {carregando && tituloDocument}
        <Fade in={carregando} mountOnEnter unmountOnExit>
          <Skeleton
            variant={skeletonVariant || 'rect'}
            height={height}
            width={width}
            className={className}
          />
        </Fade>
      </React.Fragment>
    );
  }

  const conteudoCarregando = (
    <Fade in={carregando} mountOnEnter unmountOnExit>
      <Grid
        className={classNames(
          modelo === 'fixed'
            ? classNames(classes.containerTelaCheia, className)
            : modelo === 'absolute'
              ? classNames(classes.containerTelaCheiaModal, className)
              : '',
          className,
          preencherBackground ? classes.preencherBackground : ''
        )}
        container
        direction="column"
        justify="center"
        alignItems="center"
        spacing={0}
      >
        <CircularProgress size={80} className={classes.spinner} />
        {titulo && (
          <Typography variant="h4" align="center">
            <strong>{titulo}</strong>
          </Typography>
        )}
        {mensagem && (
          <Typography align="center" variant="body1">
            {mensagem}
          </Typography>
        )}
      </Grid>
    </Fade>
  );

  return (
    <React.Fragment>
      {carregando && tituloDocument}
      {carregando && modelo === 'fixed' && <MasterPagina>{conteudoCarregando}</MasterPagina>}
      {carregando && modelo !== 'fixed' && <React.Fragment>{conteudoCarregando}</React.Fragment>}
    </React.Fragment>
  );
};
